var installedModules = {};
var moduleToHandlerMapping = {
	"99+y": {
		getter: function() { return Promise.all([__webpack_require__.e(2274), __webpack_require__.e(1432), __webpack_require__.e(6621), __webpack_require__.e(6715)]).then(function() { return function() { return __webpack_require__("20a2"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/router",
	},
	"nCaY": {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__("nKUr"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react/jsx-runtime",
	},
	"ige9": {
		getter: function() { return __webpack_require__.e(987).then(function() { return function() { return __webpack_require__("g4pe"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	"wYKt": {
		getter: function() { return Promise.all([__webpack_require__.e(2274), __webpack_require__.e(1106)]).then(function() { return function() { return __webpack_require__("YFqc"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	"2Lpl": {
		getter: function() { return Promise.all([__webpack_require__.e(8133), __webpack_require__.e(6621)]).then(function() { return function() { return __webpack_require__("x+Y2"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	"Zegd": {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(6621)]).then(function() { return function() { return __webpack_require__("Aiso"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	"jeT3": {
		getter: function() { return __webpack_require__.e(7334).then(function() { return function() { return __webpack_require__("Vvt1"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^12 || ^13 || ^14 || ^15",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	"+OUp": {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__("q1tI"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	"UwWC": {
		getter: function() { return __webpack_require__.e(9759).then(function() { return function() { return __webpack_require__("ms2o"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx",
	},
	"sH9G": {
		getter: function() { return __webpack_require__.e(882).then(function() { return function() { return __webpack_require__("tYR1"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^5.1.1",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "styled-jsx/style",
	},
	"v1W4": {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__("EbEg"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/client",
	},
	"gAx2": {
		getter: function() { return function() { return __webpack_require__("i8i4"); }; },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	"k3v3": {
		getter: function() { return __webpack_require__.e(3368).then(function() { return function() { return __webpack_require__("g4pe"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/head",
	},
	"VoJx": {
		getter: function() { return __webpack_require__.e(4953).then(function() { return function() { return __webpack_require__("Vvt1"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/dynamic",
	},
	"/zZM": {
		getter: function() { return Promise.all([__webpack_require__.e(2274), __webpack_require__.e(1106), __webpack_require__.e(4900)]).then(function() { return function() { return __webpack_require__("YFqc"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/link",
	},
	"aG+K": {
		getter: function() { return Promise.all([__webpack_require__.e(9965), __webpack_require__.e(1002)]).then(function() { return function() { return __webpack_require__("Aiso"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/image",
	},
	"PTO7": {
		getter: function() { return Promise.all([__webpack_require__.e(8133), __webpack_require__.e(8787)]).then(function() { return function() { return __webpack_require__("x+Y2"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^13.5.6",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "next/script",
	},
	"D+W7": {
		getter: function() { return __webpack_require__.e(6593).then(function() { return function() { return __webpack_require__("KAy6"); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": false,
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "react-dom/server",
	}
};
var initialConsumes = ["99+y","nCaY","ige9","wYKt","2Lpl","Zegd","jeT3","+OUp","UwWC","sH9G","+OUp","v1W4","gAx2","nCaY","VoJx","k3v3","99+y","/zZM","aG+K","PTO7"];
__webpack_require__.federation.installInitialConsumes = function() { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}); }
var chunkMapping = {
	"297": [
		"99+y"
	],
	"636": [
		"nCaY",
		"VoJx",
		"k3v3",
		"99+y"
	],
	"3739": [
		"aG+K"
	],
	"4039": [
		"/zZM"
	],
	"4563": [
		"k3v3"
	],
	"5527": [
		"ige9",
		"wYKt",
		"2Lpl",
		"Zegd",
		"jeT3",
		"+OUp",
		"UwWC",
		"sH9G"
	],
	"5973": [
		"D+W7"
	],
	"6621": [
		"gAx2"
	],
	"6703": [
		"VoJx"
	],
	"8775": [
		"nCaY"
	],
	"8792": [
		"+OUp",
		"v1W4",
		"gAx2"
	],
	"9009": [
		"PTO7"
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}